import React from 'react';

const ModalUser = params => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill={params.color || '#108EE9'}
      fillRule="nonzero"
      d="M22.855 5.333l-.734.736-11.88 11.88a2.687 2.687 0 0 0-.773 1.612l-.014.204-.035 1.131v.092c.022.836.68 1.503 1.5 1.551l.145.002 1.132-.034a2.685 2.685 0 0 0 1.665-.647l.15-.14 11.88-11.88.775-.776v16.27A2.667 2.667 0 0 1 24 28H6.667A2.667 2.667 0 0 1 4 25.333V8a2.667 2.667 0 0 1 2.667-2.667h16.188zm.046 1.882L24.785 9.1 12.972 20.91a1.332 1.332 0 0 1-.76.378l-.144.012-1.127.032a.266.266 0 0 1-.266-.198l-.008-.06v-.016l.032-1.127c.008-.292.112-.57.293-.796l.096-.108L22.901 7.215zM27.61 4.39c.485.486.518 1.252.097 1.775l-.097.109-1.884 1.883-1.883-1.883 1.883-1.884c.52-.52 1.364-.52 1.884 0z"
    />
  </svg>
);

export default ModalUser;
